import React from 'react';
import { Grid } from '@mui/material';

import { TextField, StatesSingleAutocomplete, TimezoneAutocomplete } from '@occc-app/design-system';

import { isRequired, isFloat } from '../utils';

const LocationAddressFormContent: React.FC = () => (
  <Grid container columnSpacing={3} rowSpacing={1}>
    <Grid item xs={6}>
      <TextField
        name='address.street1'
        label='Street1'
        required
        margin='normal'
        fieldProps={{
          validate: isRequired,
        }}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField name='address.street2' label='Street2' margin='normal' />
    </Grid>
    <Grid item xs={3}>
      <TextField
        name='address.city'
        label='City'
        required
        margin='normal'
        fieldProps={{
          validate: isRequired,
        }}
      />
    </Grid>
    <Grid item xs={3}>
      <StatesSingleAutocomplete
        name='address.state'
        label='State'
        inputProps={{ required: true, margin: 'normal' }}
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        name='address.zipCode'
        label='ZipCode'
        required
        margin='normal'
        type='string'
        fieldProps={{
          validate: isRequired,
        }}
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        name='address.countryCode'
        label='Country'
        required
        margin='normal'
        fieldProps={{
          validate: isRequired,
        }}
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        name='address.geoLocation.latitude'
        label='Latitude'
        margin='normal'
        fieldProps={{
          validate: isFloat,
        }}
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        name='address.geoLocation.longitude'
        label='Longitude'
        margin='normal'
        fieldProps={{
          validate: isFloat,
        }}
      />
    </Grid>
    <Grid item xs={3}>
      <TimezoneAutocomplete
        name='timezone'
        label='Timezone'
        inputProps={{ required: true, margin: 'normal' }}
      />
    </Grid>
  </Grid>
);

export default LocationAddressFormContent;
